import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { AddOperationModalComponent } from "../../../components/modal-templates/add-operation-modal/add-operation-modal.component";
import { DeleteCautionModalComponent } from "../../../components/modal-templates/delete-caution-modal/delete-caution-modal.component";
import { DeleteConfirmationComponent } from "../../../components/modal-templates/delete-confirmation/delete-confirmation.component";
import { SharedImports } from "../../../components/shared.module";
import { AutomationActions } from "../../../core/ngrx/actions/automation.actions";
import {
  selectAllServiceOperations,
  selectServiceOperationLoading,
} from "../../../core/ngrx/selectors/automation.selectors";
import { operationDeleteTableColumns } from "../../../core/table-templates/application-delete-caution-table";
import { restServiceOverviewTableColumns } from "../../../core/table-templates/rest-service-operations";
import { MessageEnum } from "../../../core/utils/message.enum";
import { BaseLayoutComponent } from "../../base-layout.component";

@Component({
  selector: "app-rest-service-overview",
  standalone: true,
  imports: [...SharedImports, CommonModule],
  templateUrl: "./rest-service-overview.component.html",
  styleUrl: "./rest-service-overview.component.scss",
})
export class RestServiceOverviewComponent
  extends BaseLayoutComponent
  implements OnInit
{
  private modalService = inject(NgbModal);
  isLoading: boolean = false;
  iconSrcDelete: string =
    "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  selectedOperations: any = [];
  options = {
    isExpandable: false,
  };
  dataSource: any;
  columns = restServiceOverviewTableColumns;
  automationProjectID: string = "";
  loadingServiceOperations$: Observable<boolean> = this.store.select(
    selectServiceOperationLoading
  );
  serviceId: string = "";
  apiServiceOperations$!: Observable<any>;
  serviceData:any;

  ngOnInit(): void {
    this.loadingServiceOperations$.subscribe((loading) => {
      this.isLoading = loading;
    });

    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectID = id;
    });

    this.projectService.getServiceId().subscribe((id: any) => {
      this.serviceId = id;
    });

    this.automatiCScriptService.getActiveNode().subscribe((item) => {
      this.serviceData = item;
    });

    this.apiServiceOperations$ = this.store.select(selectAllServiceOperations);
    this.apiServiceOperations$.subscribe((services) => {
      let dataList: any = [];
      services.forEach((service: any) => {
        dataList.push({
          ...service,
          type: "operations",
          view: "restOperationsView",
          requestType: service.type
        });
      });
      this.dataSource = dataList;
    });
  }

  addNewOperation(isEdit?: boolean, event?: any) {
    const modalRef = this.modalService.open(AddOperationModalComponent, {
      centered: true,
      size: "lg",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = {
      title:isEdit? "Update Operation" :"Add New Operation",
      saveBtnText: isEdit ? "Update" : "Add",
      isEdit: isEdit ? isEdit : false,
      data: isEdit ? event?.data?.row : null,
      url:this.serviceData?.url
    };
    modalRef.result.then((result) => {
      if (result) {
        if (isEdit) {
          this.store.dispatch(
            AutomationActions.updateServiceOperation({
              projectId: this.dataStore?.data?.id,
              automationProjectId: this.automationProjectID,
              serviceId: this.serviceId,
              id: event?.data?.row?.id,
              changes: {
                name: result?.name,
                type: result?.type,
                url: result?.url,
              },
            })
          );
        } else {
          this.store.dispatch(
            AutomationActions.addServiceOperation({
              projectId: this.dataStore?.data?.id,
              automationProjectId: this.automationProjectID,
              serviceId: this.serviceId,
              serviceOperations: result,
            })
          );
        }
      }
      console.log(result);
    });
  }

  removeOperations() {
    this.isLoading = true;

    let idList = this.selectedOperations.map((item: any) => item.id);
    this.restService
      .deleteValidationOperation(
        this.dataStore?.data?.id,
        this.automationProjectID,
        this.serviceId,
        idList
      )
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          let rowData = response?.data;
          rowData = this.assignLevels(rowData);
          console.log("row data with levels ->", rowData);
          const deletableIds = this.selectedOperations
            .filter((item: any) => !rowData?.some((d: any) => d.id === item.id))
            .map((item: any) => item.id);

          console.log("deletable ids ->", deletableIds);
          const data = {
            deleteList: deletableIds,
            skippedList: rowData,
          };

          if (
            Array.isArray(data?.skippedList) &&
            data?.skippedList?.length > 0
          ) {
            this.removeOperationCaution(data);
          } else {
            this.removeComfirmation(idList);
          }
        },
        error: (error: any) => {
          this.isLoading = false;
          this.toaster.pop({
            type: "error",
            text: MessageEnum.SERVICE_OPERATION_DELETE_VALIDATION_FAILURE,
          });
        },
      });
  }

  removeOperationCaution(tableData: any) {
    this.isLoading = false;
    var nonDeletableCount = tableData.skippedList.length;
    let modalRef = this.modalService.open(DeleteCautionModalComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
    });
    modalRef.componentInstance.configs = {
      subTitle: "Unable to Delete Selected Operations",
      cautionMessage1:
        nonDeletableCount +
        " of the selected operations are currently used in test scripts. To avoid breaking existing tests, these operations cannot be deleted.",
      cautionMessage2:
        "Only operations that are not currently in use will be removed.",
      footerMessage1:
        "You can delete the remaining operations that are not used in any scripts.",
      footerMessage2:
        "To delete the listed operations, first remove their references from the test scripts mentioned above.",
      tableData: tableData.skippedList,
      tableTitle: "Details of Operations in Use",
      deleteButtonText: "Delete Unused Operations Only",
      columns: operationDeleteTableColumns,
      projectId: this.dataStore?.data?.id,
      automationProjectId: this.automationProjectID,
    };
    modalRef.result.then((result) => {
      if (result) {
        //delete operations / bulk
        if(tableData?.deleteList?.length > 0){
          this.store.dispatch(
            AutomationActions.deleteServiceOperations({
              projectId: this.dataStore?.data?.id,
              automationProjectId: this.automationProjectID,
              serviceId: this.serviceId,
              idList: tableData?.deleteList,
            })
          );
        } 
      }
    });
  }

  removeComfirmation(idList: any) {
    let modalRef = this.modalService.open(DeleteConfirmationComponent, {
      windowClass:"delete-confirmation-window",
      centered: true,
      size: "sm",
      backdrop: "static",
    });
    modalRef.componentInstance.data = {
      title: "Confirm Deletion",
      description: `Are you sure you want to delete Operations`,
    };
    modalRef.result.then((result: any) => {
      if (result) {
        this.store.dispatch(
          AutomationActions.deleteServiceOperations({
            projectId: this.dataStore?.data?.id,
            automationProjectId: this.automationProjectID,
            serviceId: this.serviceId,
            idList: idList,
          })
        );
      }
    });
  }

  assignLevels(data: any[], level: number = 0): any[] {
    return data.map((item) => {
      const hasScript = this.containsScript(item);
      const newItem = {
        ...item,
        level,
        scriptLevel: hasScript,
      };

      if (item.children && item.children.length > 0) {
        newItem.children = this.assignLevels(item.children, level + 1);
      }

      return newItem;
    });
  }

  containsScript(item: any): boolean {
    if (item.script) {
      return true;
    } else {
      return false;
    }
  }

  changeRemoveIcon(isActive: boolean) {
    this.iconSrcDelete = isActive
      ? "../../../../../assets/images/virtusa-icons/remove-icon-light.svg"
      : "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  }

  handleActionsInTable(event: any) {
    if (event.type == "svg") {
      this.addNewOperation(true,event);
    }
  }

  refreshData() {
    this.store.dispatch(
      AutomationActions.loadServiceOperation({
        projectId: this.dataStore?.data?.id,
        automationProjectId: this.automationProjectID,
        serviceId: this.serviceId,
      })
    );
  }


  handleRowSelect(event: any) {
    this.selectedOperations = event?.data;
  }
}
